var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVehiculeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.475,
    height: 37.857,
    viewBox: "0 0 36.475 37.857",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_338",
    "data-name": "Groupe 338",
    transform: "translate(65.5 115.43)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_335",
    "data-name": "Groupe 335",
    transform: "translate(-65 -114.93)",
    opacity: 0.56
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_453",
    "data-name": "Trac\\xE9 453",
    d: "M-8.078,131.492l-3.11-.691a1.329,1.329,0,0,0-1.613,1.325v1.325c0,1.036.807,1.209,1.785,1.267h3.57c.634,0,1.152-.231,1.152-.864v-.173a2.283,2.283,0,0,0-1.785-2.188Zm-3.628,2.016v-1.44c0-.173.115-.288.288-.23l3.167.691a1.17,1.17,0,0,1,.864.979c-.115.058-4.262.058-4.319,0Zm0,0",
    transform: "translate(17.811 -107.19)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_454",
    "data-name": "Trac\\xE9 454",
    d: "M189.444,130.8l-3.167.691a2.157,2.157,0,0,0-1.728,2.131.847.847,0,0,0,.691.979c.4.115,2.995.057,4.089.057.979,0,1.728-.23,1.728-1.267v-1.325a1.3,1.3,0,0,0-1.613-1.267Zm.518,2.707c-.173.058-4.2.058-4.261.058a1.108,1.108,0,0,1,.806-.979l3.167-.691c.173-.057.288.058.288.231Zm0,0",
    transform: "translate(-160.591 -107.189)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_455",
    "data-name": "Trac\\xE9 455",
    d: "M81.895,165.871H74.178a.577.577,0,0,0-.576.576.544.544,0,0,0,.576.576h7.717a.577.577,0,0,0,.576-.576.544.544,0,0,0-.576-.576Zm0,0",
    transform: "translate(-60.299 -138.919)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_456",
    "data-name": "Trac\\xE9 456",
    d: "M81.895,190.468H74.178a.577.577,0,0,0-.576.576.544.544,0,0,0,.576.576h7.717a.577.577,0,0,0,.576-.576.544.544,0,0,0-.576-.576Zm0,0",
    transform: "translate(-60.299 -161.155)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_457",
    "data-name": "Trac\\xE9 457",
    d: "M-31.137-97.538h-1.037a2.773,2.773,0,0,0-2.419,1.325l-1.037-2.073a8.671,8.671,0,0,0,5.068-7.89,8.824,8.824,0,0,0-8.753-8.753,8.725,8.725,0,0,0-8.7,8.7,8.29,8.29,0,0,0,.519,2.937h-6.968a3.2,3.2,0,0,0-2.995,2.016l-2.419,5.01A2.9,2.9,0,0,0-62.293-97.6h-1.094A1.648,1.648,0,0,0-65-95.983v.691a1.609,1.609,0,0,0,1.613,1.612h1.67a4.937,4.937,0,0,0-1.036,3.11v3.686a6.062,6.062,0,0,0,1.5,3.916V-80.2a2.126,2.126,0,0,0,2.131,2.131h2.3A2.126,2.126,0,0,0-54.691-80.2V-81.3h14.8V-80.2a2.126,2.126,0,0,0,2.131,2.131h2.3A2.126,2.126,0,0,0-33.326-80.2v-2.764a5.7,5.7,0,0,0,1.5-3.858v-3.686a5.174,5.174,0,0,0-.461-2.073,5.023,5.023,0,0,0-.634-1.037h1.785a1.61,1.61,0,0,0,1.613-1.613v-.691a1.647,1.647,0,0,0-1.613-1.613Zm-8.178-16.24a7.582,7.582,0,0,1,7.6,7.544,7.57,7.57,0,0,1-7.544,7.544,7.57,7.57,0,0,1-7.544-7.544,7.521,7.521,0,0,1,7.487-7.544Zm-17.1,12.958a2.066,2.066,0,0,1,1.958-1.325h7.487a8.579,8.579,0,0,0,7.659,4.607,7.642,7.642,0,0,0,2.592-.4c.057.058,1.44,2.995,1.67,3.4H-59.529c.231-.345-.115.461,3.11-6.277Zm-7.429,5.529v-.691a.508.508,0,0,1,.461-.518h1.037a2.128,2.128,0,0,1,1.843,1.325c-.058.115-.173.23-.23.345h-2.649a.454.454,0,0,1-.461-.46Zm8.062,15.03a1.032,1.032,0,0,1-1.037,1.037h-2.3a1.032,1.032,0,0,1-1.036-1.037V-82.1a4.727,4.727,0,0,0,2.476.691h1.9ZM-35.4-79.225h-2.3a1.032,1.032,0,0,1-1.037-1.037v-1.094h1.9a4.731,4.731,0,0,0,2.476-.691V-80.2a1.021,1.021,0,0,1-1.036.979Zm2.534-7.717a4.241,4.241,0,0,1-3.973,4.434H-57.686c-2.3,0-3.973-2.188-3.973-4.434v-3.686a3.835,3.835,0,0,1,1.21-2.822h26.433a4.6,4.6,0,0,1,.864,1.209,4.071,4.071,0,0,1,.346,1.613v3.686Zm2.188-8.35a.454.454,0,0,1-.461.46h-2.649a1.208,1.208,0,0,1-.23-.345c.173-.173.576-1.325,1.843-1.325h1.037a.454.454,0,0,1,.461.461Zm0,0",
    transform: "translate(65 114.93)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehiculeIcon);
export default __webpack_public_path__ + "static/media/vehicule-icon.83ed654e45161049e9e011358bcdce1b.svg";
export { ForwardRef as ReactComponent };